import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ConfirmDialogData } from './confirm-dialog/_models/confirm-dialog-data.model';
import { DialogResult } from '../../models/dialog/dialog-result.model';
import { DialogButton } from '../../enums/dialog-button.enum';
import { IConfirmDialogService } from './_interfaces/confirm-dialog-service.interface';

/**
 *  A service to manage and display confirm dialogs
 */
@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService implements IConfirmDialogService {
  /**
   * @param matDialog - A reference to the MatDialog service
   */
  constructor(private matDialog: MatDialog) {}

  /**
   * Open a confirm dialog
   * @param title - The title of the confirm dialog
   * @param message - The message to display to the user
   */
  public async openConfirmDialog(
    title: string,
    message: string
  ): Promise<DialogResult<null>> {
    const dialogData = new ConfirmDialogData(title, message);
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      data: dialogData,
      width: '40rem'
    });
    const dialogResult = await dialogRef
      .afterClosed()
      .toPromise<DialogResult<null>>();
    if (dialogResult.button === DialogButton.OK) {
      return new DialogResult(DialogButton.OK);
    } else {
      return new DialogResult(DialogButton.Cancel);
    }
  }
}
